export default function showMore() {
    const elsList = document.querySelectorAll('.js-show-more');

    if (elsList.length) {
        elsList.forEach((item) => {
            const moreEventButton = item.querySelector('.js-show-more-event');
            const moreContent = item.querySelector('.js-show-more-content');

            if (moreEventButton && moreContent) {
                const moreContentHeight = moreContent.offsetHeight;
                moreContent.style.maxHeight = 0;

                moreEventButton.addEventListener('click', (e) => {
                    e.preventDefault();

                    moreContent.style.maxHeight = `${moreContentHeight}px`;
                    moreEventButton.style.display = 'none';
                });
            }
        });
    }
}
